import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const editListSlice = createSlice({
    name: 'ui/published-companies-list',
    initialState: { ...initialState, populates: ['managers', 'editors'] },
    reducers: listReducers
})

export const editListActions = editListSlice.actions
export default editListSlice.reducer
